// Dropdowns.js
import React, { useState } from "react";
import CustomDropdown from "./dropdown";
import MultiSelectDropdown from "./MultiSelectDropdown";
const Dropdowns = () => {
  const [selectedOptionBasic, setSelectedOptionBasic] = useState(null);
  const [selectedOptionSearchable, setSelectedOptionSearchable] = useState(null);

  const options = [
    { id: 1, name: "BIPOC" },
    { id: 2, name: "Menopause" },
    { id: 3, name: "Fertility" },
    { id: 4, name: "Preconception" },
    { id: 5, name: "Behavioral Health" },
    { id: 6, name: "Nutrition" },
    { id: 7, name: "Child Development" },
    { id: 8, name: "Caregiver Support" },
    { id: 9, name: "Andropause" },
    { id: 10, name: "WIN for Him" },
    { id: 11, name: "Surrogacy & Adoption" },
    { id: 12, name: "Maternity" },
    { id: 13, name: "Women's Health" },
  ];

  const handleBasicChange = (selected) => {
    setSelectedOptionBasic(selected);
  };

  const handleSearchableChange = (selected) => {
    setSelectedOptionSearchable(selected);
  };

  return (
    <div>
      <div className="col-md-12 col-lg-6 mt-5 inner-page-heading-wrapper">
        <h2 className="page-heading">Custom Dropdown Examples</h2>
      </div>
      <div className="col-12 mt-4">&nbsp;</div>
      {/* Basic Dropdown */}
      <CustomDropdown
        options={options}
        selectedOption={selectedOptionBasic}
        onChange={handleBasicChange}
        label="Basic Dropdown"
        searchable={false} // Disable search
      /><br></br>
      {/* <div>
        <p>Selected Option (Basic): {selectedOptionBasic ? selectedOptionBasic.name : 'None'}</p>
      </div> */}

      {/* Searchable Dropdown */}
      <CustomDropdown
        options={options}
        selectedOption={selectedOptionSearchable}
        onChange={handleSearchableChange}
        label="Searchable Dropdown"
        searchable={true} // Enable search
      /><br></br>
      {/* <div>
        <p>Selected Option (Searchable): {selectedOptionSearchable ? selectedOptionSearchable.name : 'None'}</p>
      </div> */}

      {/* Normal Multi-Select Dropdown */}
      <MultiSelectDropdown options={options} label="Basic Multi Select Options" searchable={false} /><br></br>

      {/* Searchable Multi-Select Dropdown */}
      <MultiSelectDropdown options={options} label="Search MultiSelect Options" searchable={true} />
    </div>
  );
};

export default Dropdowns;
